export const OnAuth0Logout = async (logout) => {
    
    const params = {
        logoutParams: {
            returnTo: window.location.origin + '/login',
        }
    }

    logout(params)

}